import { useFdrDeleteWishlistMutation } from 'fdr/schemas/mutation/wishlist/fdr-delete-wishlist.generated';
import { FdrGetActiveWishlistDocument } from 'fdr/schemas/query/wishlist/fdr-get-active-wishlist.generated';
import { FdrWishlistIconDocument } from 'fdr/schemas/query/wishlist/fdr-wishlist-icon.generated';
import { FdrWishlistOverviewDocument } from 'fdr/schemas/query/wishlist/fdr-wishlist-overview.generated';

export function useRemoveWishlist() {
  const [mutation, { loading }] = useFdrDeleteWishlistMutation({
    refetchQueries: [
      FdrWishlistOverviewDocument,
      FdrGetActiveWishlistDocument,
      FdrWishlistIconDocument,
    ],
  });

  function removeWishlist(id: string) {
    return mutation({
      variables: {
        wishlistId: id,
      },
    });
  }

  return {
    removeWishlist,
    loading,
  };
}
